var PERIOD_SOURCE_VALUES = {
    P7D: 'P7D',
    P14D: 'P14D',
    P21D: 'P21D',
    P1M: 'P1M',
    P6M: 'P6M',
    P1Y: 'P1Y',
    P2Y: 'P2Y',
    P3Y: 'P3Y',
    P4Y: 'P4Y',
    P5Y: 'P5Y',
    P7Y: 'P7Y',
    P10Y: 'P10Y',
    P15Y: 'P15Y',
};
var PURPOSE_SOURCE_VALUES = {
    MONEY: 'Money',
    REFINANCE_CREDIT: 'RefinanceCredit',
    NEW_CAR: 'NewCar',
    USED_CAR: 'UsedCar',
    MORTGAGE: 'Mortgage',
};
var PURPOSE_OPTIONS = [
    { label: 'Просто деньги', value: PURPOSE_SOURCE_VALUES.MONEY },
    { label: 'Рефинансирование кредита', value: PURPOSE_SOURCE_VALUES.REFINANCE_CREDIT },
    { label: 'Покупка нового автомобиля', value: PURPOSE_SOURCE_VALUES.NEW_CAR },
    { label: 'Покупка подержанного автомобиля', value: PURPOSE_SOURCE_VALUES.USED_CAR },
];
var PERIOD_OPTIONS = [
    { label: '7 дней', value: PERIOD_SOURCE_VALUES.P7D },
    { label: '14 дней', value: PERIOD_SOURCE_VALUES.P14D },
    { label: '21 день', value: PERIOD_SOURCE_VALUES.P21D },
    { label: '1 месяц', value: PERIOD_SOURCE_VALUES.P1M },
    { label: '6 месяцев', value: PERIOD_SOURCE_VALUES.P6M },
    { label: '1 год', value: PERIOD_SOURCE_VALUES.P1Y },
    { label: '2 года', value: PERIOD_SOURCE_VALUES.P2Y },
    { label: '3 года', value: PERIOD_SOURCE_VALUES.P3Y },
    { label: '4 года', value: PERIOD_SOURCE_VALUES.P4Y },
    { label: '5 лет', value: PERIOD_SOURCE_VALUES.P5Y },
    { label: '7 лет', value: PERIOD_SOURCE_VALUES.P7Y },
    { label: '10 лет', value: PERIOD_SOURCE_VALUES.P10Y },
    { label: '15 лет', value: PERIOD_SOURCE_VALUES.P15Y },
];
var AMOUNT_LIMITS = {
    MAX: 1000000,
    MIN: 1000,
    STEP: 1000,
};

export { AMOUNT_LIMITS, PERIOD_OPTIONS, PERIOD_SOURCE_VALUES, PURPOSE_OPTIONS, PURPOSE_SOURCE_VALUES };
//# sourceMappingURL=constants.js.map
